import React, { useState, useEffect, useRef } from "react";
//Redux
import { useDispatch } from "react-redux";
import { Select, translateMessage } from "@delibrandev/utils";
import { ScheduleEditor } from "../../../../../../components/scheduleEditor";
import { ConfigurationPanel } from "../..";
import { getAllBusinessHours, updateCorporationBussinessHours } from "../../../../../../api/configuration";
import { TbPlus } from "react-icons/tb";
import { setAlert } from "../../../../../../reducers/userConfigSlice";

export const Schedule = () => {
  const dispatch = useDispatch();
  const [businessHours, setBusinessHours] = useState([]);
  const [scheduleSelected, setScheduleSelected] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const createInFlight = useRef(false);

  /*********** API REQUESTS ************/
  const query = async () => {
    setLoading(true);
    try {
      const response = await getAllBusinessHours();
      if (response?.error !== false || !Array.isArray(response.data)) throw new Error("Invalid schedules response");
      setBusinessHours(response.data);
      setScheduleSelected(previous => response.data.some(hour => hour.businessHoursId === previous) ? previous : response.data[0]?.businessHoursId || null);
      setLoadError(false);
    } catch { setLoadError(true); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    query();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleShedule = (e) => {
    setScheduleSelected(e);
  };

  const newShedule = async () => {
    if (createInFlight.current) return;
    createInFlight.current = true; setCreating(true);
    try {
    const payload = {
      type: "CUSTOM",
      name: "Nuevo horario",
      lastOrderTime: "30",
      isContinuous: false,
      dayInfo: {
        MONDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: false,
        },
        TUESDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: false,
        },
        WEDNESDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: false,
        },
        THURSDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: false,
        },
        FRIDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: false,
        },
        SATURDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: true,
        },
        SUNDAY: {
          openingTime: "08:00",
          closingTime: "20:00",
          splitOpeningTime: "17:00",
          splitClosingTime: "14:00",
          isClosed: true,
        },
      },
    };

    const response = await updateCorporationBussinessHours(payload);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("Ok.");
      query();
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      console.log("Error en la operación");
    }
    } catch { dispatch(setAlert("No se ha podido crear el horario. Vuelve a intentarlo.")); }
    finally { createInFlight.current = false; setCreating(false); }
  };

  const content = (
      <div className="categoryDetails mt-3">
        <div className="row">
          <div className="col-12 flex-end" style={{ marginTop: "-35px" }}>
            <button type="button" className="schedule-save" disabled={creating || loading || loadError} onClick={newShedule}><TbPlus aria-hidden="true" /> {creating ? "Creando…" : "Crear horario"}</button>
          </div>
        </div>
        {loadError && <div><p role="alert">No se han podido cargar los horarios. Revisa tu conexión o acceso y vuelve a intentarlo.</p><button type="button" disabled={loading} onClick={query}>Reintentar horarios</button></div>}
        {loading && <p role="status">Cargando horarios…</p>}
        {!loadError && !loading && businessHours.length === 0 && <p>No hay horarios definidos. Crea uno para empezar.</p>}
        {!loadError && businessHours && businessHours.length > 0 && (
          <div className="row">
            <div className="col-12">
              <Select
                values={businessHours.map((hour) => {
                  return { id: hour.businessHoursId, name: hour.name };
                })}
                callback={handleShedule}
                label="Horario seleccionado"
                description="Seleccione el horario a modificar"
                classname={""}
                id={"businessHoursId"}
                value={scheduleSelected ? scheduleSelected : businessHours && businessHours[0]?.businessHoursId}
              />
            </div>
          </div>
        )}

        <div className="mt-3">
          {!loadError && <ScheduleEditor key={scheduleSelected} schedule={businessHours.find((item) => item.businessHoursId === scheduleSelected)} refresh={query} />}
        </div>
      </div>
    );

  return <ConfigurationPanel title="Gestión de horarios" content={content} action={() => null} hasButtonSave={false} />;
};
